var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',{staticClass:"page-title"},[_vm._v("Performance Configuration "),_c('button',{staticClass:"btn btn-success m-t-5 btn-sm",attrs:{"type":"submit"}},[_vm._v("OKRs Activated")])])])])
}]

export { render, staticRenderFns }